import * as Types from './../../mutationTypes'

export default {
    [Types.SET_MODEL](state, data) {
        state.module = data
    }
}